import { z } from 'zod';
export const messageRateLimitPolicyGuard = z.object({
    sendWindow: z.number().int().positive(),
    maxSendsPerRecipient: z.number().int().positive(),
});
/**
 * The default message rate limit policy. Applied to every tenant and not
 * tenant-configurable.
 *
 * - `sendWindow`: 600 seconds (10 minutes)
 * - `maxSendsPerRecipient`: 10 per window
 *
 * The window is short and rolling on purpose: a falsely-throttled recipient
 * regains capacity within ~10 minutes rather than being unable to receive a
 * message for up to an hour.
 */
export const defaultMessageRateLimitPolicy = Object.freeze({
    sendWindow: 600,
    maxSendsPerRecipient: 10,
});
/**
 * Internal, ops-only per-tenant override of {@link defaultMessageRateLimitPolicy}. Stored under the
 * `messageRateLimitOverride` key in `riven_auth_configs` (formerly `riven_auth_configs`) and not exposed by any API — it exists solely
 * as a relief valve for a legitimately high-volume tenant that trips the system cap.
 *
 * Every field is optional: the effective policy is resolved per field as `override ?? system
 * default`, so a partial override only changes the fields it sets.
 */
export const messageRateLimitOverrideGuard = messageRateLimitPolicyGuard.partial();
